const MENU_TYPES = {
    DETAIL: "detail",
    VISIBILITY: "visibility",
};

const Items = (that) => [
    {
        enabled: true,
        key: MENU_TYPES.DETAIL,
        label: that?.$t("message.channelSettings") || "Kanal Ayarları",
        icon: {
            type: "material-icons",
            name: "settings",
        },
    },
    {
        enabled: true,
        key: MENU_TYPES.VISIBILITY,
        label: that?.$t("message.visibility") || "Görünürlük",
        icon: {
            type: "material-icons",
            name: "visibility",
        },
    },
];

export default {
    MENU_TYPES,
    Items,
};
